import type { SvgIconProps } from '@mui/material'
import HomeIcon from '@mui/icons-material/HomeOutlined'
import ContraIcon from '@mui/icons-material/SwapHorizOutlined'
import PaymentIcon from '@mui/icons-material/OutboxOutlined'
import ReceiptIcon from '@mui/icons-material/MoveToInboxOutlined'
import JournalIcon from '@mui/icons-material/EditNoteOutlined'
import SalesIcon from '@mui/icons-material/SellOutlined'
import PurchaseIcon from '@mui/icons-material/ShoppingCartOutlined'
import DayBookIcon from '@mui/icons-material/MenuBookOutlined'
import OutstandingIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import LedgerIcon from '@mui/icons-material/ImportContactsOutlined'
import TrialIcon from '@mui/icons-material/BalanceOutlined'
import BalanceSheetIcon from '@mui/icons-material/AssessmentOutlined'
import PnlIcon from '@mui/icons-material/TrendingUpOutlined'
import RegisterIcon from '@mui/icons-material/ListAltOutlined'
import CashIcon from '@mui/icons-material/LocalAtmOutlined'
import BankIcon from '@mui/icons-material/AccountBalanceOutlined'
import VatIcon from '@mui/icons-material/ReceiptOutlined'
import AccountsIcon from '@mui/icons-material/AccountTreeOutlined'
import SettingsIcon from '@mui/icons-material/SettingsOutlined'
import TripIcon from '@mui/icons-material/RouteOutlined'
import InvoiceIcon from '@mui/icons-material/RequestQuoteOutlined'
import FleetIcon from '@mui/icons-material/LocalShippingOutlined'
import TripRegisterIcon from '@mui/icons-material/FactCheckOutlined'
import ProfitIcon from '@mui/icons-material/InsightsOutlined'
import ItemsIcon from '@mui/icons-material/Inventory2Outlined'
import StoresIcon from '@mui/icons-material/WarehouseOutlined'
import OpeningStockIcon from '@mui/icons-material/PlaylistAddCheckOutlined'
import PurchasesIcon from '@mui/icons-material/AddShoppingCartOutlined'
import InvSalesIcon from '@mui/icons-material/PointOfSaleOutlined'
import StockMovesIcon from '@mui/icons-material/SyncAltOutlined'
import StockOnHandIcon from '@mui/icons-material/InventoryOutlined'
import StockCardIcon from '@mui/icons-material/TimelineOutlined'
import VanStockIcon from '@mui/icons-material/AirportShuttleOutlined'
import SalesByItemIcon from '@mui/icons-material/LeaderboardOutlined'
import LowStockIcon from '@mui/icons-material/ProductionQuantityLimitsOutlined'
import VanSalesIcon from '@mui/icons-material/PhoneAndroidOutlined'
import VanPhonesIcon from '@mui/icons-material/SendToMobileOutlined'
import type { MenuIcon as Name } from '../nav/menu'

const ICONS: Record<Name, typeof HomeIcon> = {
  home: HomeIcon, contra: ContraIcon, payment: PaymentIcon, receipt: ReceiptIcon,
  journal: JournalIcon, sales: SalesIcon, purchase: PurchaseIcon,
  daybook: DayBookIcon, outstanding: OutstandingIcon, ledger: LedgerIcon,
  trial: TrialIcon, balance: BalanceSheetIcon, pnl: PnlIcon, register: RegisterIcon,
  cash: CashIcon, bank: BankIcon, vat: VatIcon, accounts: AccountsIcon,
  settings: SettingsIcon, trip: TripIcon, invoice: InvoiceIcon, fleet: FleetIcon,
  tripRegister: TripRegisterIcon, profit: ProfitIcon,
  items: ItemsIcon, stores: StoresIcon, openingStock: OpeningStockIcon,
  purchases: PurchasesIcon, invSales: InvSalesIcon,
  stockMoves: StockMovesIcon, stockOnHand: StockOnHandIcon, stockCard: StockCardIcon,
  vanStock: VanStockIcon, salesByItem: SalesByItemIcon, lowStock: LowStockIcon,
  vanSales: VanSalesIcon, vanPhones: VanPhonesIcon,
}

/** The 18px line icon for a menu entry. Decorative: the label carries the meaning. */
export default function MenuIcon({ name, ...rest }: { name: Name } & SvgIconProps) {
  const Icon = ICONS[name]
  return <Icon aria-hidden sx={{ fontSize: 18 }} {...rest} />
}
